import { render } from "./InventoryValue.vue?vue&type=template&id=1ec2afe9&scoped=true"
import script from "./InventoryValue.vue?vue&type=script&lang=js"
export * from "./InventoryValue.vue?vue&type=script&lang=js"

import "./InventoryValue.vue?vue&type=style&index=0&id=1ec2afe9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec2afe9"]])

export default __exports__